import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-open-line text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                MGB<span className="text-primary-600">漫画网</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              MGB漫画网是一个主打阅读体验的漫画阅读平台。双页模式与滚动阅读自由切换、夜间模式护眼、目录跳转快速定位、进度记忆自动保存，让每一部作品都读得流畅顺手。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-wechat-fill", "ri-qq-fill", "ri-weibo-fill", "ri-bilibili-fill"].map((ic) => (
                <a
                  key={ic}
                  href="#"
                  aria-label="社区"
                  rel="nofollow"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:bg-secondary-500 hover:text-background-50"
                >
                  <i className={`${ic} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">网站导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {[
                ["阅读功能", "#features"],
                ["热门作品", "#popular"],
                ["题材分类", "#categories"],
                ["阅读指南", "#guide"],
              ].map(([t, href]) => (
                <li key={href}>
                  <a href={href} className="text-foreground-600 hover:text-primary-600 transition-colors">
                    {t}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">开始阅读</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/reader" className="text-foreground-600 hover:text-primary-600 transition-colors">
                  阅读体验页
                </Link>
              </li>
              <li>
                <a href="#faq" className="text-foreground-600 hover:text-primary-600 transition-colors">
                  常见问题
                </a>
              </li>
              <li>
                <a href="#" rel="nofollow" className="text-foreground-600 hover:text-primary-600 transition-colors">
                  反馈建议
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© 2026 MGB漫画网 · 让每一部作品都读得顺手</p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
            <a href="#" rel="nofollow" className="hover:text-foreground-800 transition-colors">
              用户协议
            </a>
            <a href="#" rel="nofollow" className="hover:text-foreground-800 transition-colors">
              隐私政策
            </a>
            <a href="#" rel="nofollow" className="hover:text-foreground-800 transition-colors">
              内容规范
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}